import * as React from 'react';
import PropTypes from 'prop-types';
var SvgActionsKudoNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("style", null), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.633C15 5.848 14.394 5 13.416 5h-3.362c.208-.742.374-1.599.262-2.188-.24-1.257-1.57-2.044-1.835-2.189a1 1 0 00-1.469.725l-.307 1.996-2.44 4.522-3.124 1.201a1 1 0 00-.567 1.311l1.833 4.5a1 1 0 001.305.548L7.197 14h4.613c.833 0 1.549-.656 1.664-1.52l.275-1.923c.531-.406.83-.979.83-1.602 0-.274-.062-.572-.166-.83.378-.378.587-.901.587-1.492zM3.333 14.5L1.5 10l2.047-.787 1.816 4.456-2.03.831zm10.18-6.931a.502.502 0 00-.121.756c.075.086.187.381.187.63 0 .473-.35.761-.558.891a.503.503 0 00-.231.354l-.307 2.144c-.049.367-.345.656-.673.656H7l-.712.291L4.48 8.855l.49-.188 2.697-5L8 1.5s1.169.641 1.333 1.5c.164.859-.667 3-.667 3h4.749c.361 0 .585.329.585.633 0 .241-.063.681-.487.936z",
    id: "actions_kudo_normal_xsmall_svg__Icons"
  }));
});
SvgActionsKudoNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgActionsKudoNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgActionsKudoNormalXsmall;